/**
 * @author lifei & gll
 * 模块说明：用户中心-组织模块
 */
import { Service } from '@/tools'

export class OrgService<T extends TUser.Org> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TUser.Org}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：业务组/组织架构树
   * /api/user/org/v1/getOrgTree
   */
  getOrgTree = <K extends T['ApiGetOrgTree']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGetOrgTree', data)

  /**
   * 功能：业务组/组织架构树
   */
  getOrgListTree = <K extends T['ApiGetOrgListTree']>(): Promise<K['res']> => this.post2('v1/ApiGetOrgListTree')

  /**
   * 功能：查询当前登录人所属公司下子部门组织树 /api/user/org/v1/getCompanyDeptTree
   */
  getCompanyDeptTree = <K extends T['ApiGetCompanyDeptTree']>(): Promise<K['res']> => this.post2('v1/ApiGetCompanyDeptTree')
  /**
   * 功能：查看组织详情
   */
  detail = <K extends T['ApiDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDetail', data)

  /**
   * 功能：编辑组织
   */
  update = <K extends T['ApiUpdate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdate', data)

  /**
   * 功能：新增组织
   */
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data)

  /**
   * 功能：查询组织下已关联的用户列表
   */
  withOrgUserList = <K extends T['ApiWithOrgUserList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiWithOrgUserList', data)

  /**
   * 功能：查询没有关联的组织的用户列表
   */
  withoutOrgUserList = <K extends T['ApiWithoutOrgUserList']>(): Promise<K['res']> => this.post2('v1/ApiWithoutOrgUserList')

  /**
   * 功能：查询没有关联的组织的用户列表
   */
  addOrgUser = <K extends T['ApiAddOrgUser']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddOrgUser', data)

  /**
   * 功能：负责人接口 库存中心-实体仓使用
   */
  // getCompanyUserInfoList = <K extends T['ApiGetCompanyUserInfoList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGetCompanyUserInfoList')

  /**
   * 功能：获取当前登录用户的公司信息
   */
  getLoginUserCompanyInfo = <K extends T['ApiGetLoginUserCompanyInfo']>(): Promise<K['res']> => this.post2('v1/ApiGetLoginUserCompanyInfo')
  /**
   * 根据组织公司id查询关联的结算公司信息
   * /api/user/org/v1/getBusinessCompanyInfo
   */
  getBusinessCompanyInfo = <K extends T['ApiGetBusinessCompanyInfo']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiGetBusinessCompanyInfo', data)

  /**
   * 查询钉钉组织树
   * 接口地址:/api/user/org/v1/getDingOrgTree
   */
  getDingOrgTree = <K extends T['ApiGetDingOrgTree']>(data: K['req']): Promise<K['res']['data']> => this.post2('v1/ApiGetDingOrgTree', data)

  /**
   * 查询钉钉组织树
   * 接口地址:/api/user/org/v1/getDingOrgTree
   */
  getOrgTreeWithDing = <K extends T['ApiGetOrgTreeWithDing']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGetOrgTreeWithDing', data)

  /**
   * 查询钉钉组织树
   * 接口地址:/api/user/org/v1/bindDingOrg
   */
  bindDingOrg = <K extends T['ApiBindDingOrg']>(data: K['req']): Promise<K['res']['data']> => this.post2('v1/ApiBindDingOrg', data)
   /**
   * 获取业务属性
   * 接口地址:  /api/user/org/v1/getDeptByGroupId
   */
  getDeptByGroupId = <K extends T['ApiGetDeptByGroupId']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGetDeptByGroupId', data)

  /**
   * 根据地区查基层店
   * 接口地址:  `/api/user/org/v1/getOrgCompanyList`
   */
  getOrgCompanyList = <K extends T['ApiGetOrgCompanyList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGetOrgCompanyList', data)
}
